import toast from 'react-hot-toast';
import { formatApiError } from './formatApiError';

type Options = {
  fallbackMessage?: string;
  operation?: string;
};

export function handleApiError(error: unknown, options?: Options): void {
  toast.error(formatApiError(error, options?.operation ?? options?.fallbackMessage));
}
